export const formDefaultValues = {
  name: '',
  description: '',
  turnsCount: null,
  price: null,
}
